/* Maison Belleval — runtime minimal. Aucune dépendance. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au défilement -------------------------------------------- */
  function initReveal() {
    var targets = document.querySelectorAll('.mb-reveal:not(.is-visible)');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* Entête en surimpression : bascule sur fond crème au défilement -------- */
  function initHeader() {
    var header = document.querySelector('.mb-header--overlay');
    if (!header) return;

    var threshold = window.innerHeight * 0.7;
    var ticking = false;

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', function () {
      threshold = window.innerHeight * 0.7;
      update();
    }, { passive: true });

    update();
  }

  /* Fil défilant : on duplique le contenu pour boucler sans couture ------- */
  function initMarquee() {
    document.querySelectorAll('.mb-marquee__track:not([data-cloned])').forEach(function (track) {
      track.setAttribute('data-cloned', 'true');
      var original = Array.prototype.slice.call(track.children);
      original.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* Menu plein écran : verrouillage du défilement + fermeture clavier ----- */
  function initMenu() {
    document.querySelectorAll('details.mb-menu:not([data-bound])').forEach(function (details) {
      details.setAttribute('data-bound', 'true');

      details.addEventListener('toggle', function () {
        document.body.style.overflow = details.open ? 'hidden' : '';
        if (details.open) {
          var first = details.querySelector('.mb-menu__list a');
          if (first) first.focus({ preventScroll: true });
        }
      });

      details.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !details.open) return;
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  }

  /* Hauteur de fenêtre réelle sur mobile (barre d'adresse iOS) ----------- */
  function initViewportUnit() {
    function set() {
      document.documentElement.style.setProperty('--mb-vh', window.innerHeight * 0.01 + 'px');
    }
    set();
    window.addEventListener('resize', set, { passive: true });
    window.addEventListener('orientationchange', set);
  }


  /* Sélecteurs pays/langue : soumission au changement ------------------- */
  function initLocalization() {
    document.querySelectorAll('[data-localization-select]:not([data-bound])').forEach(function (select) {
      select.setAttribute('data-bound', 'true');
      select.addEventListener('change', function () {
        select.form.submit();
      });
    });
  }

  function boot() {
    initReveal();
    initHeader();
    initMarquee();
    initMenu();
    initViewportUnit();
    initLocalization();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* L'éditeur de thème réinjecte les sections : on rebranche à chaud. */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
